import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Circle } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { AdminHeading } from "@/pages/admin/AdminShell";

export default function AdminOverview() {
  const { t, fmt } = useLang();
  const [stats, setStats] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
    api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  const cards = [
    ["a_revenue", fmt(stats?.revenue ?? 0), "stat-revenue"],
    ["a_total_orders", stats?.orders ?? 0, "stat-orders"],
    ["a_pending_orders", stats?.pending ?? 0, "stat-pending"],
    ["a_low_stock", stats?.low_stock ?? 0, "stat-low-stock"],
  ];
  const steps = [
    ["a_setup_products", (stats?.products ?? 0) > 0, "/admin/products"],
    ["a_setup_cities", (stats?.cities ?? 0) > 0, "/admin/delivery"],
    ["a_setup_payment", !!(settings?.cod_enabled || settings?.card_enabled || (settings?.whatsapp_enabled && settings?.whatsapp_number)), "/admin/settings"],
    ["a_setup_wa", !!settings?.whatsapp_number, "/admin/settings"],
  ];

  return (
    <div data-testid="admin-overview">
      <AdminHeading title={t("a_overview")} />
      <div className="grid grid-cols-2 gap-px bg-[#241914]/10 lg:grid-cols-4">
        {cards.map(([k, v, id]) => (
          <div key={k} className="bg-[#F7F3EB] p-6">
            <p className="text-xs text-[#241914]/70">{t(k)}</p>
            <p data-testid={id} className="font-display mt-3 text-3xl">{v}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 max-w-xl bg-[#0B0B0C] p-8 text-[#F7F3EB]">
        <p className="eyebrow">{t("a_setup")}</p>
        <ul className="mt-6 space-y-4">
          {steps.map(([k, ok, to]) => (
            <li key={k}>
              <Link to={to} data-testid={`setup-step-${k}`} className="flex items-center gap-3 text-sm hover:text-[#C6A76A]">
                {ok ? <Check className="h-4 w-4 text-[#C6A76A]" /> : <Circle className="h-4 w-4 text-[#F7F3EB]/40" strokeWidth={1.2} />}
                <span className={ok ? "text-[#F7F3EB]/60 line-through" : ""}>{t(k)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
